import { render, staticRenderFns } from "./PickupTable.vue?vue&type=template&id=23976a66&scoped=true"
import script from "./PickupTable.vue?vue&type=script&lang=js"
export * from "./PickupTable.vue?vue&type=script&lang=js"
import style0 from "./PickupTable.vue?vue&type=style&index=0&id=23976a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23976a66",
  null
  
)

export default component.exports